// @flow
import * as React from 'react';
import { StyledButton } from './styles';

type Props = {
    children: React.Node,
    className?: string
};

const TextButton = ({ children, className, ...props }: Props) => (
    <StyledButton {...props} className={className}>
        {children}
    </StyledButton>
);

export default TextButton;



// WEBPACK FOOTER //
// ./src/components/widgets/buttons/text/buttons-text.component.js